/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from "react";
import Spinner from "react-bootstrap/Spinner";

const ChatInput = ({ onSubmit, isLoading }) => (
    <form onSubmit={onSubmit} className="mt-4">
        <div className="d-flex align-items-center">
            <input
                type="text"
                className="form-control me-2"
                style={{ width: '500px' }}
                placeholder="Type your message..."
                disabled={isLoading}
            />
            <button className="btn btn-info d-flex align-items-center" disabled={isLoading}>
                {isLoading ? (
                    <span className="d-flex align-items-center">
                        <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-2"
                        />
                        Sending...
                      </span> ) : (
                    'Send'
                )}
            </button>
        </div>
    </form>
);

export default ChatInput;
